<template>
  <div class="prodcut">
    <div class="question-title">
      <div style="display: flex;">
        <span>
          渠道
        </span>
        <span class="question-title-require">
          *
        </span>
      </div>
    </div>
    <div class="prodcut-type">
      <el-radio-group
        v-model="answer.channel"
        @change="channelChange"
      >
        <el-radio
          v-for="option in channelList"
          :name="option.channel"
          :key="option.channel"
          :label="option.channel"
        >
        </el-radio>
      </el-radio-group>
    </div>
    <div class="question-title">
      <div style="display: flex;">
        <span>
          二级机构
        </span>

        <span class="question-title-require">
          *
        </span>
      </div>
    </div>
    <div>
      <div class="picker">
        <van-field
          readonly
          clickable
          label=""
          :value="answer.org"
          placeholder="请选择二级机构"
          @click="showPicker = true"
        />
        <van-popup
          v-model="showPicker"
          round
          position="bottom"
        >
          <van-picker
            show-toolbar
            :columns="orgList"
            @cancel="showPicker = false"
            @confirm="onOrgConfirm"
          >
            <div slot="columns-top">
              <van-search
                v-model="keyWord"
                show-action
                placeholder="请输入搜索关键词"
                @search="onSearch"
              >
                <template #action>
                  <div @click="onSearch">搜索</div>
                </template>
              </van-search>
            </div>
            <template v-slot:option="option">

              <div @click="onOrgConfirm(option)">
                {{ option }}
              </div>
            </template>
          </van-picker>
        </van-popup>
      </div>
    </div>

  </div>
</template>

<script>
import mixins from "./mixins";

export default {
  name: "channelAndLevel",
  components: {},
  mixins: [mixins],
  data() {
    return {
      answer: {
        channel: "",
        org: "",
      },
      showPicker: false,
      total: "",

      channelList: [],
      keyWord: "",
      originOrgList: [],
      orgList: [],
      orgMap: {},
      datasource: {},
      first: true,
    };
  },
  computed: {},
  watch: {},
  created() {
    this.init();
  },
  methods: {
    channelChange(value) {
      const { orgMap, channelList } = this;
      this.answer.channel = value;
      let key = "";
      channelList.forEach((item) => {
        if (item.channel === value) {
          key = item.data_key;
        }
      });
      this.answer.org = "";
      this.orgList = orgMap[key];
      this.originOrgList = orgMap[key];
      this.answerChange(this.answer);
    },
    onOrgConfirm(option) {
      this.answer.org = option;
      this.showPicker = false;
      this.answerChange(this.answer);
    },
    init() {
      const { question } = this;
      const datasource = JSON.parse(question.datasource);
      const orgMap = {};
      datasource.data.forEach((item) => {
        orgMap[item.key] = item.data;
      });
      this.orgMap = orgMap;
      this.datasource = datasource;
      this.channelList = datasource.channels;
    },

    onSearch() {
      const { originOrgList, keyWord } = this;
      const options = [...originOrgList];
      let result = [];
      if (!keyWord) {
        result = options;
      } else {
        options.forEach((option) => {
          if (option.indexOf(keyWord) !== -1) {
            result.push(option);
          }
        });
      }

      this.orgList = result;
    },
  },
};
</script>

<style lang="scss" scoped>
.prodcut {
  .el-button {
    width: 100%;
    margin-top: 10px;
  }
  .add-address {
    margin-bottom: 20px;
  }
}
.prodcut-box {
  border: 1px solid #dcdfe6;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
  .van-cell {
    border: none;
  }
}
.prodcut-box-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .el-button {
    width: 70px;
  }
}
.prodcut-type {
  margin-bottom: 10px;
}
</style>